var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayS48Filled = function SvgIconPlayS48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32.18 21.5-11.6-6.8a2.91 2.91 0 0 0-2.91-.01c-.9.52-1.46 1.48-1.46 2.52v13.6c0 1.04.56 2 1.46 2.52.45.26.94.38 1.44.38s1.01-.13 1.47-.4l11.6-6.8c.9-.53 1.43-1.46 1.43-2.5s-.54-1.98-1.43-2.5v-.01Z",
    fill: "current"
  })));
};
export default SvgIconPlayS48Filled;